// utils
import { AllFormsFilter } from "./AllFormsFilters";

import { SearchServiceSort } from "react/api/hooks";

import isArray from "../../../../../../utils/IsArray";

export const generateCsvDownloadUrl = (filters: AllFormsFilter, sort?: SearchServiceSort) => {
	let url = `/api/search/?service=review_report&`;

	if (filters) {
		Object.keys(filters).forEach((key) => {
			const value = isArray(filters[key]) ? filters[key].join(",") : filters[key];
			url += `&${key}=${encodeURIComponent(value)}`;
		});
	}

	if (sort) {
		url += `&sort=${sort.direction}(${sort.name})`;
	}

	url += `&format=csv_stream`;
	return url;
};
